var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssetEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 354.217,
    height: 200.51,
    viewBox: "0 0 244.217 129.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17189",
    "data-name": "Group 17189",
    transform: "translate(-5430 14402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17136",
    "data-name": "Group 17136",
    transform: "translate(5611.055 -14402) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M63.683,8.007,88.958,65.442a4.3,4.3,0,0,1-2.2,5.673L35.967,93.463a4.3,4.3,0,0,1-5.671-2.2l-29.93-68a4.3,4.3,0,0,1,2.205-5.671L42.523,0,42.9.143Z",
    transform: "translate(0 0)",
    fill: "#dee7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M8.07,13.137a3.507,3.507,0,0,1-3.208-2.092L0,0,20.782,7.864,9.48,12.839A3.529,3.529,0,0,1,8.07,13.137Z",
    transform: "translate(42.9 0.139)",
    fill: "#bdc3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M21.918,12.774l-4.3,1.9-6.288-3.087L9.36,18.3,5.326,20.083,8.277,10.8,0,6.952,4.154,5.12,10.032,8.1l1.7-6.314L15.79,0,13.042,8.883Z",
    transform: "translate(38.951 45.895)",
    fill: "#cdd7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M40.559,1.778,1.3,19.053a.928.928,0,1,1-.746-1.7L39.812.078a.928.928,0,0,1,.747,1.7Z",
    transform: "translate(16.525 17.666)",
    fill: "#cdd7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M40.558,1.777,1.3,19.052a.928.928,0,1,1-.748-1.7L39.809.079a.928.928,0,1,1,.749,1.7Z",
    transform: "translate(18.462 21.906)",
    fill: "#cdd7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M40.557,1.779,1.3,19.056a.928.928,0,0,1-.749-1.7L39.81.079a.928.928,0,1,1,.747,1.7Z",
    transform: "translate(20.398 26.148)",
    fill: "#cdd7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M40.559,1.776,1.3,19.054a.928.928,0,1,1-.749-1.7L39.811.079a.928.928,0,0,1,.748,1.7Z",
    transform: "translate(22.333 30.39)",
    fill: "#cdd7fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M40.559,1.777,1.3,19.055a.928.928,0,1,1-.747-1.7L39.811.079a.928.928,0,1,1,.748,1.7Z",
    transform: "translate(23.95 34.791)",
    fill: "#cdd7fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17139",
    "data-name": "Group 17139",
    transform: "translate(5430 -14400.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17135",
    "data-name": "Group 17135",
    transform: "translate(0 76.779) rotate(-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M88.657,46.624,54.4,99.2a4.305,4.305,0,0,1-5.955,1.257L1.954,70.156A4.3,4.3,0,0,1,.7,64.2L41.265,1.954A4.3,4.3,0,0,1,47.221.7L83.789,24.532l.087.393,4.781,21.7Z",
    transform: "translate(0 0)",
    fill: "#dee7fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M23.918,40.832l-6.2-4.039.355-13.561-12.261,5.8L0,25.246l17.1-7.669L17.226,0l5.989,3.9-.487,12.806L34.14,11.023l5.849,3.813-16.31,7.456Z",
    transform: "translate(27.53 30.336)",
    fill: "#cdd7fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4750",
    "data-name": "Path 4750",
    d: "M12.508,20.8,1.82,15.094a3.437,3.437,0,0,1-1.415-4.65L5.979,0Z",
    transform: "matrix(0.588, -0.809, 0.809, 0.588, 59.903, 20.984)",
    fill: "#bdc3d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17140",
    "data-name": "Group 17140",
    transform: "translate(5513 -14401.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M8128.628,7550.111v80.8a5.542,5.542,0,0,1-5.54,5.542h-71.445a5.543,5.543,0,0,1-5.542-5.544v-95.665a5.542,5.542,0,0,1,5.542-5.542h56.2l.372.365Z",
    transform: "translate(-8046.101 -7529.699)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M9762.882,7559.718h-15.9a4.509,4.509,0,0,1-4.51-4.511V7539.67Z",
    transform: "translate(-9680.354 -7539.306)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M8633.179,9076.27h0a1.449,1.449,0,0,1-1.375-1c-.524-1.543-2.234-3.066-4.869-4.294a36.711,36.711,0,0,0-27.147,0c-2.635,1.228-4.343,2.751-4.867,4.294a1.451,1.451,0,1,1-2.757-.906c.777-2.332,2.981-4.42,6.4-6.015a39.57,39.57,0,0,1,29.591,0c3.42,1.595,5.626,3.683,6.4,6.015A1.45,1.45,0,0,1,8633.179,9076.27Z",
    transform: "translate(-8572.097 -9009.245)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M8730.152,8620.57a6.011,6.011,0,1,1-6.011-6.01A6.011,6.011,0,0,1,8730.152,8620.57Z",
    transform: "translate(-8693.521 -8574.836)",
    fill: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M9311.622,8620.57a6.011,6.011,0,1,1-6.012-6.01A6.012,6.012,0,0,1,9311.622,8620.57Z",
    transform: "translate(-9253.7 -8574.836)",
    fill: "#b9b9b9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetEmptyState);
export default __webpack_public_path__ + "static/media/asset-empty-state.38edb5fc047c3ed3e02055f7c1dff655.svg";
export { ForwardRef as ReactComponent };